export interface SelectOptionConfig {
  label: string
  value: string
}

export interface Address {
  streetAddress: string[]
  city: string
  postalCode?: string
  country: string
  state?: string
}

export enum PhoneNumberType {
  Home = 'HOME',
  Business = 'BUSINESS',
  Cellular = 'CELLULAR',
  Fax = 'FAX',
  Telex = 'TELEX',
  OnCheque = 'ON_CHEQUE',
  Other = 'OTHER',
}

export const PhoneNumberDisplayMapping = {
  [PhoneNumberType.Home]: 'Home',
  [PhoneNumberType.Business]: 'Business',
  [PhoneNumberType.Cellular]: 'Cell',
  [PhoneNumberType.Fax]: 'Fax',
  [PhoneNumberType.Telex]: 'Telex',
  [PhoneNumberType.OnCheque]: 'OnCheque',
  [PhoneNumberType.Other]: 'Other',
}

export interface PhoneNumber {
  phoneNumber: string
  phoneNumberType: PhoneNumberType
  extension: string
}
